export const POST_LOGIN = "/staff/login";
export const VERIFY_2FA = "/staff/verify-2fa";
export const CHANGE_PASSWORD = "/staff/change-password";
export const TOGGLE_2FA = "/staff/toggle-2fa";
export const DASHBOARD_OVERVIEW = "/dashboard";
export const STAFF_PROFILE = "/staff/profile";
export const BUSINESS_PROFILE = "/businesses/profile";
export const BUSINESS_PROFILE_UPDATE = "/businesses/updateProfile";
export const BUSINESS_REVIEWS = "/reviews/business";
export const REVIEW_TOP_REQUESTS = "/reviews/top-requests";
export const REVIEW_TOP_REQUESTS_PENDING = "/reviews/top-requests/pending";
export const REVIEW_TOP_REQUESTS_STATUS = "/reviews/top-requests/status";
export const REVIEW_TOP_REQUESTS_APPROVE = "/reviews/top-requests";
export const REVIEW_TOP_REQUESTS_REJECT = "/reviews/top-requests";

// ==================================  URL ===================================================
//
export const SURPLUS_CATEGORY = "/surplus-categories";
export const BUSINESS = "/businesses";
export const STAFFS = "/staff";
export const OFFERS = "/offers";
export const COUNTRIES = "/countries";
export const CITIES = "/cities";
export const CATEGORIES = "/categories";
export const ORDERS = "/orders";
export const ADMIN_PAYMENTS = "/payments";

// ================================== END OF  URL ===================================================
